// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2J_uF","large":"styles_large__1r2Qz"};